// extracted by mini-css-extract-plugin
export default {"add_users_modal":"styles_add_users_modal__PmrRk","add_users_table":"styles_add_users_table__sS+S+"};